import React, { ReactElement, ReactNode } from "react";
import * as ui from "../native";
import { ContextData } from "./BuildContext";
import D3EFeature from "../models/D3EFeature";
import D3EAppTemplate from "../models/D3EAppTemplate";
import ThemeWrapper from "../components/ThemeWrapper";
import GlobalFunctions from "../utils/GlobalFunctions";
import { StyleThemeData } from "../components/ThemeWrapper";

export type RouterController = (node: ReactNode) => void;

const pageRouters: Map<string, RouterController> = new Map<
  string,
  RouterController
>();

export default class PageNavigator {
  public static defaultOverlay: ui.OverlayController;
  public static themeUpdateListener = () => {};
  public kIsWeb = true;
  public ctx: ContextData;
  public constructor(ctx: ContextData) {
    this.ctx = ctx;
  }
  public static addListener(target: string, listener: RouterController) {
    pageRouters.set(target, listener);
  }
  public static removeListener(target: string) {
    pageRouters.remove(target);
  }
  public static of(ctx: ContextData): PageNavigator {
    return new PageNavigator(ctx);
  }
  public wrapTheme(widget: ReactNode): ReactNode {
    let mediaQuery = ui.MediaQuery.of(this.ctx);

    return ThemeWrapper({ child: widget });
  }
  public push(
    replace: boolean,
    widget: ReactNode,
    title: string,
    path: string,
    target: string
  ): void {
    if (this.kIsWeb) {
      if (replace) {
        window.history.replaceState(null, title, path);
      } else {
        window.history.pushState(null, title, path);
      }
    }

    widget = this.wrapTheme(widget);

    if (!target) {
      target = "";
    }

    let listener = pageRouters.get(target);

    if (listener) {
      listener(widget);
    }
  }
  public pop(): void {
    this.close();
  }
  public close(): boolean {
    if (this.ctx.popup) {
      this.ctx.popup.hidePopup({});

      return true;
    } else {
      return false;
    }
  }
  public pushContactSupport(
    d3eParams?: Partial<{ replace: boolean; target: string }>
  ): void {
    let replace = d3eParams?.replace ?? true;

    let target = d3eParams?.target;

    this.push(
      replace,
      GlobalFunctions.ContactSupport({}),
      "",
      "#contact-support",
      target
    );
  }
  public pushStudioAppsPage(
    d3eParams?: Partial<{ replace: boolean; target: string }>
  ): void {
    let replace = d3eParams?.replace ?? true;

    let target = d3eParams?.target;

    this.push(
      replace,
      GlobalFunctions.StudioAppsPage({}),
      "",
      "#studio apps page",
      target
    );
  }
  public pushStudioFeaturesPage(
    d3eParams?: Partial<{
      replace: boolean;
      target: string;
      featureList: Array<D3EFeature>;
      templates: Array<D3EAppTemplate>;
    }>
  ): void {
    let replace = d3eParams?.replace ?? true;

    let target = d3eParams?.target;

    let featureList = d3eParams?.featureList;

    let templates = d3eParams?.templates;

    this.push(
      replace,
      GlobalFunctions.StudioFeaturesPage({
        featureList: featureList,
        templates: templates,
      }),
      "",
      "#studio features page",
      target
    );
  }
  public applyTheme(d3eParams?: Partial<{ theme: string }>): void {
    let theme = d3eParams?.theme;

    /*
TODO
*/

    switch (theme) {
      case "DarkTheme": {
        StyleThemeData.current = StyleThemeData.createDarkTheme();

        PageNavigator.themeUpdateListener();

        /*
TODO ThemeBuilder.of(this.ctx).rebuild();
*/
        break;
      }

      case "LightTheme": {
        StyleThemeData.current = StyleThemeData.createLightTheme();

        PageNavigator.themeUpdateListener();

        /*
TODO ThemeBuilder.of(this.ctx).rebuild();
*/
        break;
      }
      default: {
        StyleThemeData.current = StyleThemeData.createDarkTheme();

        PageNavigator.themeUpdateListener();

        /*
TODO ThemeBuilder.of(this.ctx).rebuild();
*/
      }
    }
  }
  public getProjectThemeNames(): string[] {
    return ["DarkTheme", "LightTheme"];
  }
  public getCurrentThemeName(): string {
    return StyleThemeData.current.themeName;
  }
}
